import { useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import React from 'react';
import { AlertConfirm, TextInput } from '../../UI';


const CopyPortalModal = ({
	open, requestClose, translate, portal, refetch, setModalCopy
}) => {
	const [portalToCopy, setPortalToCopy] = React.useState('');
	const [newPortalName, setNewPortalName] = React.useState('');
	const [status, setStatus] = React.useState('IDDLE');
	const client = useApolloClient();
	const [error, setError] = React.useState();


	const copyPortal = async () => {
		const result = await client.mutate({
			mutation: gql`
		        mutation CopyPortal($idOrigin: Int!, $idTarget: Int!, $newPortalName: String!){
		            copyCouncilPortal(idOrigin: $idOrigin, idTarget: $idTarget, newPortalName: $newPortalName){
                        success
                        message
		            }
		        }
		 `,
			variables: {
				idOrigin: portal.council.id,
				idTarget: +portalToCopy,
				newPortalName,
			}
		});

		if (result?.errors?.length > 0) {
			setStatus('ERROR');
			setError(result?.errors[0].message);
			// return;
		} else {
			setStatus('SUCCESS');
		}
		refetch();
		setModalCopy(false);
	};


	return (
		<AlertConfirm
			requestClose={requestClose}
			open={open}
			loadingAction={status === 'LOADING'}
			acceptAction={copyPortal}
			buttonAccept={translate.accept}
			buttonCancel={translate.cancel}
			error={error}
			bodyText={
				<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
					<span style={{ color: 'red' }}>
						CUIDADO: Esta operación sobreescribirá cualquier personalización que exista actualmente. La operación no se podrá deshacer.
					</span>
					<span>
						Esta operación sobreescribirá la configuración del portal dado cuyo id se pasa por parámetro, el campo nombre modificará el nombre del portal con el id seleccionado.
					</span>
					{status === 'IDDLE' &&
						<>
							<TextInput
								floatingText={'Id de la reunión a copiar'}
								onChange={event => setPortalToCopy(event.nativeEvent.target.value)}
								errorText={error}
								value={portalToCopy}
							/>
							<TextInput
								floatingText={'Nombre para el nuevo portal'}
								onChange={event => setNewPortalName(event.nativeEvent.target.value)}
								errorText={error}
								value={newPortalName}
							/>
						</>
					}
					{status === 'LOADING' && 'LOADING...'}
					{status === 'SUCCESS' && 'Se ha ejecutado correctamente'}
					{status === 'ERROR' && `Se ha producido un error: ${error}`}

				</div>
			}
			title={translate.confirm}
		/>
	);
};

export default CopyPortalModal;
